import React, { Component } from 'react';
import hospital from '../videos/medapp.mp4';

class Hospital extends Component{

render(){

    return(
        <div className="project-page">
            <h1 className="project-heading">Hospital</h1>
            <video controls>
            <source src={hospital} type="video/mp4"/>
            Your browser does not support the video tag.
            </video>
        <div className="project-text">
            <h4>Description</h4>
            <p>This is a hospital records keeping application which is used to retreive, update deleted and create entries into a database. It can also do this for any database information and does not have to be limited to it's hospital application. This type of setup can be used in any application where database records are updated regularly and where it needs to constantly be viewed. This project was made with visual studio/C#/dotNet and the database technology used is Microsoft SQL server.</p>
            <p>As can be seen in the video above the process for using this application is as follows: The first page is the login page which uses the database to authenticate the user details. The next page is the main page where the application is used. This includes the patient, doctor, medication and appointments user controls. Clicking on any one of the buttons on the side panel brings the relevant user control panel to the front. The database records can be created, updated and deleted from these user control panels. There are many features that can be added to this application to make it ready for a hospital use case but it does require the advice of an experienced member of that particular industry to appcomplish.</p>
            </div>
        </div>
    )
}

}

export default Hospital;